module.exports = __webpack_public_path__ + "static/media/no-data.d1f05af6.svg";